import api from "./api";
import api1 from "./api1";
import api2 from "./common";
const apis = { ...api, ...api1, ...api2 };
export default apis;
